<template>
  <div>
     <el-upload
      ref="upload"
      class="upload-demo"
      :action="action"
      :headers="headers"
      :data="property"
      :file-list="fileList"
      :auto-upload="false"
      accept=".xlsx, .xls"
      :before-upload="beforeUpload"
      :on-error="onError"
      :on-success="onSuccess"
      :on-change="onChange"
      :on-remove="onChange"
      :limit="1"
    >
      <el-button slot="trigger" size="small" >上传附件</el-button>
      <div slot="tip" class="el-upload__tip">支持xls、xlsx文件，单个文件不大于2M</div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    selectedType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      property: { property: this.selectedType },
      fileList: [],
      headers: { Authorization: this.getToken(), 'X-TENANT-ID': this.getCTenantId() },
      action: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_CRM_SERVICE') + '/customer/custom-import'
    }
  },
  watch: {
    selectedType(val) {
      this.$set(this.property, 'property', val)
    }
  },
  methods: {
    getToken() {
      return localStorage.getItem('Authorization')
    },
    // 获取租户id
    getCTenantId() {
      return localStorage.getItem('X-TENANT-ID')
    },
    // 文件改变时进行非空和文件大小校验
    onChange(file, fileList) {
      this.$emit('beforeUpload', file, fileList)
    },
    beforeUpload(file, fileList) {
    // const isLt2M = file.size / 1024 / 1024 < 2
    // if (isLt2M) {
    //   return true
    // } else {
    //   return false
    // }
    },
    onError(err, file, fileList) {
      console.log('err', err)
      this.$message({
        message: '文件上传失败',
        type: 'error',
        duration: 2000
      })
    },
    onSuccess(response, file, fileList) {
      if (response.code === '2000') {
        this.$emit('uploadFile', response.data)
      } else {
        // 表单提交失败
        this.$message({
          message: '导入异常',
          type: 'error',
          duration: 2000
        })
      }
    },
    doSubmit() {
      this.$refs.upload.submit()
    }
  }
}
</script>

<style scoped>
  .excel-upload-input {
    display: none;
    z-index: -9999;
  }
  .drop {
    margin: 0 auto;
    float: left;
    border-radius: 5px;
    text-align: left;
    color: #bbb;
    position: relative;
  }
  .el-upload__tip{
    display: inline-block;
    margin-left: 20px;
  }
</style>
